<template>
    <div
        class="list-transition-item opacity-100 w-full border-b border-grey-blue"
    >
        <sidebar-card
            @click="isLocked ? '' : $emit('select')"
            class="bg-white-dark"
            :class="{
                'hover:bg-primary-lightest cursor-pointer': isLocked == false,
            }"
            :isFinished="section.is_finished"
            :drawerActive="isLocked ? undefined : activeIndex == index"
            :isLocked="isLocked"
            :text="`Abschnitt ${index + 1}: ${section.name}`"
        >
            <template #description v-if="!isLocked">
                <div class="w-full text-grey text-sm mt-2 select-none">
                    {{ sectionDescription }}
                </div></template
            >
        </sidebar-card>
        <div v-if="activeIndex == index">
            <slide-card
                :slide="slide"
                :index="slideIndex"
                v-for="(slide, slideIndex) in section.slides"
                :key="slideIndex"
                :class="{ 'border-t border-grey-light': slideIndex != 0 }"
            />
        </div>
    </div>
</template>

<script>
import { computed, defineComponent, reactive } from "@vue/runtime-core";
import { useStore } from "vuex";
import { COURSE_TYPES, STORE_TYPES } from "../../../store/types";
import SidebarCard from "./SidebarCard.vue";
import SlideCard from "./SlideCard.vue";

export default defineComponent({
    name: "CourseSidebar",
    components: {
        SidebarCard,
        SlideCard,
    },
    emits: ["select"],
    props: {
        section: { required: true },
        index: { type: Number, required: true },
        activeIndex: {
            type: Number,
            default: null,
        },
    },
    setup(props) {
        const store = useStore();
        /**
         *  State
         */
        const state = reactive({});
        /**
         *  Functions
         */

        /**
         *  Computed
         */
        const GET_COURSE = computed(
            () =>
                store.getters[
                    `${STORE_TYPES.COURSES}/${COURSE_TYPES.GET_COURSE}`
                ]
        );
        const sectionDescription = computed(() => {
            let countSections = 0;
            let countSectionsFinished = 0;
            let countSectionLength = 0;

            for (let index = 0; index < props.section.slides.length; index++) {
                const slide = props.section.slides[index];
                countSections++;
                if (slide.progress.is_finished) {
                    countSectionsFinished++;
                }
                countSectionLength += slide.minutes;
            }
            return `${countSectionsFinished} / ${countSections} | ${countSectionLength} Min.`;
        });
        const isLocked = computed(() => {
            return props.index != 0
                ? GET_COURSE.value.sections[props.index - 1].is_finished ==
                      false
                : GET_COURSE.value.target_agreement_finished == false;
        });
        /**
         *  Created
         */

        return { state, GET_COURSE, sectionDescription, isLocked };
    },
});
</script>
